const FINANCY_TYPE_CODE_BUDGET = "hse.Бюджетное";
const FINANCY_TYPE_CODE_PAID = "hse.СОплатойОбучения";
const APPLICATION_STATUS_ACCEPTED = "hse.Принята";
const APPLICATION_STATUS_REJECTED = "hse.Отклонена";
const APPLICATION_STATUS_CHANGES = "hse.ТребуетсяКорректировка";
const APPLICATION_STATUS_SENT = "hse.ОтправленаВВуз";
const APPLICATION_STATUS_RECEIVED = "hse.ДоставленаВВуз";

export const state = () => ({
    list: [],
    id: null,
    isInitCompetition: false,
    applicationNumber: null,
    status: null,
    isEditApplication: false,
    isNewRegion: false,
    date: null,
    fileToReject: null,
    fileToAgree: null,
    financingLimitation: false,
    selectedCompetition: [],
    documentForRefusal: {},
    documentForCancellation: {},
    scores: {},
    isFalse: false,
    competitionErrors: {
        enrollAgreement: '',
        enrollRevocation: '',
    }
})

export const actions = {
    async setList({ commit }, params) {
        await this.dispatch('setViewMode', params)
        commit('SET_EDIT_APP', params?.status?.PROPERTIES)
        commit('SET_LIST', params.applications)
        commit('SET_ID', params.applicationId)
        commit('SET_NUMBER', params.applicationNumber)
        commit('SET_STATUS', params.status)
        commit('SET_DATE', params.applicationDate)
        commit('SET_IS_NEW_REGION', params.applicationHasQuotaNewRegions)
    },
    async refreshApplication({ dispatch }) {
        const response = await this.$api("getUserApplicationList");
        await dispatch('setList', response.data);
    },
    async refreshListApplications({ commit }) {
        try {
            const response = await this.$api("getUserApplicationList");
            if (response?.data?.applications) {
                commit('SET_LIST', response?.data?.applications)
            }
        } catch {
            // Не удалось обновить данные
        }
    },
    async init({ dispatch, commit, state }) {
        if (state.isInitCompetition) {
            return
        }
        commit('SET_INIT_COMPETITION', true)
        try {
            await dispatch('refreshApplication')
        } catch {
            // ERROR::: Не получены активные заявления
        }
    },
    selectCompetition({ commit }, params) {
        commit('SELECT_COMPETITION', params)
    },
    deleteAllSelectedCompetition({ commit }, params) {
        commit('DELETE_SELECTED')
    },
    setScore({ commit }, params) {
        commit('SET_SCORE', params)
    },
    async setFile({ commit, state }, params) {
        // saveEntranceAdmission - принимает id и file
        // updateEntranceAdmission - id, application и file
        // deleteEntranceAdmission - id
        switch (params.type) {
            // отказ от поступления
            case 'refuse':
                // this.$api("updateEntranceAdmission", {id: params.id, application: params.application, file: params.file}, "POST")
                //     .then(result => {
                //       console.log(result)
                //     })
                //console.log("refuse", {id: params.id, application: params.application, file: params.file})
                break;
            // отказ от участия в конкурсах
            case 'cancel':
                // this.$api("saveEntranceAdmission", {id: params.id, file: params.file}, "POST")
                //     .then(result => {
                //       console.log(result)
                //     })
                //console.log("cancel", {id: params.id})
                break;
            // отзыв согласия
            case 'reject':
                commit('SET_FILE', params)
                break;
            // подача согласия
            default:
                commit('SET_FILE', params)
                break;
        }
    },
    setCompetitionError({ commit }, error) {
        commit('SET_COMPETITION_ERROR', error);
        setTimeout(() => {
            commit('CLEAR_COMPETITION_ERROR', error.block);
        }, 10000)
    },
    clearCompetitionError({ commit }, block) {
        commit('CLEAR_COMPETITION_ERROR', block);
    },
}

export const mutations = {
    SET_LIST(state, competitions) {
        let competitionsArray = []
        for (let [key, value] of Object.entries(competitions)) {
            let competition = {
                title: key,
                groups: value
            }
            competition.groups.forEach(item => {
                const statuses = [{
                    id: 0,
                    title: 'Не подано'
                },
                {
                    id: 1,
                    title: 'Подано'
                },
                {
                    id: 2,
                    title: 'Отозвано'
                }
                ]
                // console.log('item.group :>> ', item.group);
                if (!item.group.agreement && !item.group.agreementCancel) {
                    item.group.agreementStatus = statuses[0].id
                } else if ((item.group.agreement && !item.group.agreementCancel && !item.group.statusA.code === 'hse.Отклонен') ||
                    (item.group.agreement && item.group.agreementCancel && item.group.statusA.code === "hse.Отклонен")) {
                    item.group.agreementStatus = statuses[1].id
                } else if ((item.group.agreement && item.group.agreementCancel && item.group.statusA.code === 'hse.Принят' && !item.group.statusA.code === "hse.Отклонен") ||
                    (item.group.agreement && !item.group.agreementCancel && item.group.statusA.code === 'hse.Отклонен')) {
                    item.group.agreementStatus = statuses[2].id
                } else {
                    const cancelDate = Date.parse(item.group.agreementCancelDate)
                    const agreementDate = Date.parse(item.group.agreementDate)
                    item.group.agreementStatus = cancelDate >= agreementDate ? statuses[2].id : statuses[1].id
                }
                if (item.group.financingType.code !== FINANCY_TYPE_CODE_PAID && item.group.agreementStatus === 1) {
                    state.financingLimitation = true
                }

            })
            competitionsArray.push(competition)
        }
        state.list = competitionsArray
    },
    SET_IS_NEW_REGION(state, value) {
        state.isNewRegion = value ?? false
    },
    SET_ID(state, params) {
        state.id = params
    },
    SET_EDIT_APP(state, params) {
        let result = false
        if (params) {
            result = params.EDIT_REQUEST === 'Y'
        }
        state.isEditApplication = result
    },
    SET_INIT_COMPETITION(state, value) {
        state.isInitCompetition = value ?? false
    },
    SET_DATE(state, params) {
        state.date = params
    },
    SET_NUMBER(state, params) {
        state.number = params
    },
    SET_STATUS(state, params) {
        state.status = params
    },
    SET_FILE(state, params) {
        switch (params.type) {
            // отказ от поступления
            case 'refuse':
                state.documentForRefusal = params.file
                break;
            // отказ от участия в конкурсах
            case 'cancel':
                state.documentForCancellation = params.file
                break;
            // отзыв согласия
            case 'reject':
                state.list.forEach(competition => {
                    competition.groups.forEach(item => {
                        if (item.application === params.id) {
                            item.group.agreementCancel = true
                            item.group.statusA.code = 'hse.Новый'
                            item.group.agreementCancelDate = new Date().toISOString()
                            item.group.agreementStatus = 2
                            state.fileToAgree = null
                            if (item.group.financingType.code !== FINANCY_TYPE_CODE_PAID) {
                                state.financingLimitation = false
                            }
                        }
                    })
                })
                state.fileToReject = params.file
                break;
            // подача согласия
            default:
                state.list.forEach(competition => {
                    competition.groups.forEach(item => {
                        if (item.application === params.id) {
                            item.group.agreement = true
                            item.group.statusA.code = 'hse.Новый'
                            item.group.agreementDate = new Date().toISOString()
                            item.group.agreementStatus = 1
                            state.fileToReject = null
                            if (item.group.financingType.code !== FINANCY_TYPE_CODE_PAID) {
                                state.financingLimitation = true
                            }
                        }
                    })
                })
                state.fileToAgree = params.file
                break;
        }
    },
    DELETE_SELECTED(state) {
        state.selectedCompetition = []
    },
    SELECT_COMPETITION(state, params) {
        if (params.status) {
            state.selectedCompetition.push(params.id)
            state.isFalse = true
        } else {
            state.selectedCompetition = state.selectedCompetition.filter(
                el => el !== params.id)
        }
    },
    SET_SCORE(state, scores) {
        state.scores = scores
    },
    SET_COMPETITION_ERROR(state, error) {
        state.competitionErrors[error.block] = error.message;
    },
    CLEAR_COMPETITION_ERROR(state, block) {
        state.competitionErrors[block] = ""
    },
}

export const getters = {
    getListOfCompetition: (state) => {
        return state.list
    },
    getId: (state) => {
        return state.id
    },
    getNumber: (state) => {
        return state.number
    },
    getNewRegionState: (state) => {
        return false; //AISPK25-191
        //return state.isNewRegion
    },
    getDate: (state) => {
        return state.date
    },
    getStatusId: (state) => {
        return state.status ? state.status.ID : null
    },
    getStatusName: (state) => {
        return state.status ? state.status.NAME : ""
    },
    getStatusCode: (state) => {
        return state.status ? state.status.CODE : ""
    },
    getselectedCompetition: (state) => {
        return state.selectedCompetition
    },
    getStatus: (state) => {
        return state.isFalse
    },
    getAgreementFile: (state) => {
        return state.fileToAgree
    },
    getRevocationFile: (state) => {
        return state.fileToReject
    },
    getTotalScores(state) {
        return state.scores
    },
    getErrors: (state) => {
        return state.competitionErrors
    },
    getFinancingLimitation: (state) => {
        return state.financingLimitation
    },
    getFinancingBudget: () => {
        return FINANCY_TYPE_CODE_BUDGET;
    },
    getFinancingPaid: () => {
        return FINANCY_TYPE_CODE_PAID;
    },
    canEditApplication: (state) => {
        return state.isEditApplication
    },
    getAvailableStatuses: () => {
        return {
            'APPLICATION_STATUS_ACCEPTED': APPLICATION_STATUS_ACCEPTED,
            'APPLICATION_STATUS_CHANGES': APPLICATION_STATUS_CHANGES,
            'APPLICATION_STATUS_RECEIVED': APPLICATION_STATUS_RECEIVED,
            'APPLICATION_STATUS_REJECTED': APPLICATION_STATUS_REJECTED,
            'APPLICATION_STATUS_SENT': APPLICATION_STATUS_SENT
        };
    }
}
